import type { QueryInterface } from './query.interface';

export interface PlaceDetailsQueryInterface extends QueryInterface {
    placeId: string;
}
